import DefaultMonitor from "./default";

class PageMonitor extends DefaultMonitor {
    _element = undefined;

    // iPad does not catch window-scroll event
    // so, we will attach to the biggest div instead
    mainContentDiv = undefined;

    get mainContent() {
        if (!this.layoutManager.isTouch) {
            return window;
        } else {
            if (!this.mainContentDiv) {
                this.mainContentDiv = document.getElementById("main-content");
            }
            return this.mainContentDiv;
        }
    }

    get scrollTop() {
        return this.layoutManager.isTouch ? this.mainContent.scrollTop : window.pageYOffset;
    }

    get scrollLeft() {
        return this.layoutManager.isTouch ? this.mainContent.scrollLeft : window.pageXOffset;
    }

    handleScroll() {
        if (this.layoutManager.onScroll) {
            this.layoutManager.onScroll({ scrollTop: this.scrollTop, scrollLeft: this.scrollLeft });
        }
        super.handleScroll();
    }

    watch(element) {
        super.watch(element);
        this.mainContent.addEventListener("scroll", this.handleScroll, false);
        window.addEventListener("resize", this.handleResize, false);
    }

    unwatch() {
        super.unwatch();
        this.mainContent.removeEventListener("scroll", this.handleScroll, false);
        window.removeEventListener("resize", this.handleResize, false);
        this.handleResize.cancel();
    }

    isNearBottom() {
        const isNearPage = this.scrollTop + window.innerHeight > this.layoutManager.runwayLength - 400;
        return isNearPage;
    }

    handleViewportChange() {
        const { layoutManager } = this;
        if (this._element) {
            const { top, width } = this._element.getBoundingClientRect();
            layoutManager.setViewportDimensions(width, window.innerHeight, top + this.scrollTop);
        }
    }
}

export default PageMonitor;
